import styled from '@emotion/styled';
import { fontSize, fontWeight, spacing } from 'presentations/views/styles';
import Popover from 'presentations/views/components/atoms/Popover';
import Icon from 'presentations/views/components/atoms/Icon';
import IconButton from 'presentations/views/components/atoms/IconButton';
import { gray01, gray02 } from 'presentations/views/styles/color';
import { useMemo } from 'react';
import { getDateTime } from 'infras/datetime';

interface Props {
  onDelete: (name: string) => void;
  onClose: (name: string) => void;
  anchor: HTMLElement;
  timeZone: string;
}

export default function Component(props: Props) {
  const dt = useMemo(() => {
    return getDateTime().setZone(props.timeZone);
  }, [props.timeZone]);

  return (
    <Popover
      anchor={props.anchor}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={props.onClose}
      maxHeight={400}
      isKeepMounted={false}
    >
      <Container>
        <StyledIconButton onClick={props.onDelete}>
          <DeleteIcon name="delete" />
        </StyledIconButton>
        <Title>{props.timeZone}</Title>
        <Long>{dt.offsetNameLong}</Long>
        <Offset>{`GMT${dt.toFormat('ZZ')}`}</Offset>
      </Container>
    </Popover>
  );
}

const Container = styled.div`
  min-width: 300px;
  padding: ${spacing(20)};
  position: relative;
`;
const Title = styled.div`
  font-size: ${fontSize(16)};
  font-weight: ${fontWeight('bold')};
  display: flex;
  align-items: center;
  margin-bottom: ${spacing(2)};
`;
const StyledIconButton = styled(IconButton)`
  position: absolute;
  top: 16px;
  right: 16px;
`;
const Long = styled.div`
  font-size: ${fontSize(13)};
  margin-bottom: ${spacing(2)};
`;
const Offset = styled.div`
  color: ${gray01};
  margin-right: ${spacing(8)};
  min-width: 56px;
`;
const DeleteIcon = styled(Icon)`
  color: ${gray01};
  width: 20px !important;
  height: 20px !important;
`;
